import ClipLoader from "react-spinners/ClipLoader";
import { useEffect, useRef } from "react";
import "./styles/Loader.css";

function Loader({ loading, messages = [] }) {
  const messagesEndRef = useRef(null);

  // Auto-scroll to bottom when new messages arrive
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  return (
    <div className="loading-container">
      <ClipLoader color={"#123abc"} loading={loading} size={150} />

      <div className="messages-container">
        <h3>Processing ...</h3>
        <div className="messages-list">
          {messages.length > 0 ? (
            messages.map((msg, index) => (
              <div key={index} className="message-item">
                <span className="message-bullet">•</span>
                <span className="message-text">{msg}</span>
              </div>
            ))
          ) : (
            <div className="message-item">
              <span className="message-text">Initializing...</span>
            </div>
          )}
          <div ref={messagesEndRef} />
        </div>
      </div>
    </div>
  );
}

export default Loader;
